import Lang from 'lang.js';
import messages from './messages.json';

import locale from './locale';

const lang = new Lang({locale, messages});
export default lang;


// WEBPACK FOOTER //
// ./src/lang/translator.js